module.exports = __webpack_public_path__ + "img/money-card.9f2fd693.png";